/* ═══════════════════════════════════════════════════════════
   Site-wide behaviour. Loaded on every page; page-specific interaction
   lives in that page's own script.

   Things that have bitten us:
   · Observe .dw itself, never a hardcoded svg.dw — .dw is not always on the <svg>.
   · Every behaviour must no-op when its elements are absent: this file is
     concatenated and runs once, on every page.
   ═══════════════════════════════════════════════════════════ */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ── 1 · Header ────────────────────────────────────────── */
  var nav = $(".nav");
  if (nav) {
    var solid = function () { nav.classList.toggle("solid", scrollY > 40); };
    solid(); addEventListener("scroll", solid, { passive: true });

    var burger = $(".burger", nav);
    if (burger) {
      burger.addEventListener("click", function () {
        var open = nav.classList.toggle("open");
        burger.setAttribute("aria-expanded", open ? "true" : "false");
      });
      $$(".navlinks a", nav).forEach(function (a) {
        a.addEventListener("click", function () { nav.classList.remove("open"); });
      });
    }
    // Highlight the current page by comparing the filename
    var here = (location.pathname.split("/").pop() || "index.html").toLowerCase();
    $$(".navlinks a").forEach(function (a) {
      var h = (a.getAttribute("href") || "").split("/").pop().toLowerCase();
      if (h && h === here) a.setAttribute("aria-current", "page");
    });
  }

  /* ── 2 · Split headings into characters ────────────────── */
  $$("[data-split]").forEach(function (el) {
    if (el.dataset.done) return;
    el.dataset.done = "1";
    /* ⚠ Per-character <i> plus inline-block makes EVERY gap between two letters a
     legal line-break point, so headings split mid-word ("…AND THE P / EOPLE…").
     Each word therefore gets wrapped in .sw (white-space:nowrap). */
    var out = "", n = 0;
    var esc = function (c) {
      return c === "&" ? "&amp;" : c === "<" ? "&lt;" : c === ">" ? "&gt;" : c;
    };
    el.textContent.split(/(\s+)/).forEach(function (tok) {
      if (!tok) return;
      if (/^\s+$/.test(tok)) { out += " "; return; }
      out += '<span class="sw">';
      tok.split("").forEach(function (ch) {
        out += '<i style="transition-delay:' + (n++ * 26) + 'ms">' + esc(ch) + "</i>";
      });
      out += "</span>";
    });
    el.innerHTML = out;
  });

  /* ── 3 · Line art: measure each path and write it into --L ── */
  var SHAPES = "path,line,circle,rect,polyline,polygon,ellipse";
  $$(".dw").forEach(function (host) {
    $$(SHAPES, host).forEach(function (el) {
      var len = 0;
      try { len = el.getTotalLength ? el.getTotalLength() : 0; } catch (e) { len = 0; }
      if (!len) {                       // rect / polygon have no getTotalLength in some browsers
        var b = el.getBBox ? el.getBBox() : null;
        len = b ? (b.width + b.height) * 2 : 400;
      }
      el.style.setProperty("--L", Math.ceil(len) + 1);
      // Stagger each path slightly so it reads as a hand drawing
      el.style.transitionDelay = (Math.random() * 260 | 0) + "ms";
    });
  });

  /* ── 4 · Scroll reveal (IntersectionObserver, geometry fallback) ── */
  var targets = $$(".rv, .dw, [data-split]");
  function light(el) {
    if (el.classList.contains("in") || el.classList.contains("drawn")) return;
    el.classList.add(el.classList.contains("dw") ? "drawn" : "in");
    if (el.classList.contains("dw")) el.classList.add("in");
  }
  if (reduced) {
    targets.forEach(light);
  } else if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { light(e.target); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.06 });
    targets.forEach(function (t) { io.observe(t); });
  }
  // Geometry fallback: IntersectionObserver is unreliable in iframes and old webviews
  function sweep() {
    var vh = innerHeight || 800, left = 0;
    targets.forEach(function (el) {
      if (el.classList.contains("in") || el.classList.contains("drawn")) return;
      if (el.getBoundingClientRect().top < vh * 0.92) light(el); else left++;
    });
    if (!left) removeEventListener("scroll", sweep);
  }
  addEventListener("scroll", sweep, { passive: true });
  sweep(); requestAnimationFrame(sweep); setTimeout(sweep, 700);

  /* ── 5 · Hefei office hours ────────────────────────────── */
  $$("[data-hefei]").forEach(function (el) {
    function tick() {
      var n = new Date();
      var h = new Date(n.getTime() + (n.getTimezoneOffset() + 480) * 60000);
      var hh = h.getHours(), mm = h.getMinutes();
      var open = hh >= 9 && hh < 18;
      el.innerHTML = '<b>' + String(hh).padStart(2, "0") + ":" + String(mm).padStart(2, "0") +
        '</b> <span>Hefei UTC+8 &middot; ' +
        (open ? "open now, usually answered within 2 hours"
              : "closed &mdash; first reply in the morning") + "</span>";
      el.classList.toggle("is-open", open);
    }
    tick(); setInterval(tick, 30000);
  });

  /* ── 6 · Counting numbers ──────────────────────────────── */
  $$("[data-count]").forEach(function (el) {
    var to = parseFloat(el.dataset.count), done = false;
    function run() {
      if (done || el.getBoundingClientRect().top > innerHeight * .95) return;
      done = true;
      if (reduced) { el.textContent = to.toLocaleString(); return; }
      var t0 = performance.now(), dur = 1100;
      (function step(t) {
        var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(to * e).toLocaleString();
        if (p < 1) requestAnimationFrame(step);
      })(t0);
    }
    run(); addEventListener("scroll", run, { passive: true });
  });

  /* ── 7 · Quote list, kept across pages in localStorage ──── */
  var KEY = "argent.rfq";
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) { return []; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} paint(); }
  function paint() {
    var n = read().length;
    $$("[data-rfq-count]").forEach(function (el) {
      el.textContent = n; el.closest("[data-rfq-badge]") &&
        el.closest("[data-rfq-badge]").classList.toggle("has", n > 0);
    });
  }
  window.ARGENT = {
    rfq: read, rfqCount: function () { return read().length; },
    add: function (item) {
      var v = read();
      if (!v.some(function (x) { return x.code === item.code; })) v.push(item);
      write(v); return v.length;
    },
    remove: function (code) { write(read().filter(function (x) { return x.code !== code; })); },
    clear: function () { write([]); }
  };
  paint();

  /* ── 8 · Anchor scrolling clears the fixed header ──────── */
  $$('a[href^="#"]').forEach(function (a) {
    a.addEventListener("click", function (e) {
      var id = a.getAttribute("href");
      if (id.length < 2) return;
      var t = $(id);
      if (!t) return;
      e.preventDefault();
      var y = t.getBoundingClientRect().top + scrollY - 78;
      scrollTo({ top: y, behavior: reduced ? "auto" : "smooth" });
    });
  });
})();

/* ── Product mega-menu ─────────────────────────────────────
   Product lines on the left, that line's series cards on the right.
   Three things that matter:
   · 140ms grace on mouse-out — the pointer has to cross a gap between the
     trigger and the panel, and closing instantly makes it unclickable. */
(function () {
  var nd = document.querySelector("[data-nd]");
  if (!nd) return;
  var trigger = nd.querySelector("a[aria-expanded]");
  var panel = nd.querySelector(".nd-panel");
  var lines = [].slice.call(nd.querySelectorAll("[data-nd-line]"));
  var panes = [].slice.call(nd.querySelectorAll("[data-nd-panel]"));
  if (!trigger || !panel) return;

  var desktop = function () { return matchMedia("(min-width: 901px)").matches; };
  var timer = null;

  function open(on) {
    if (!desktop()) return;
    clearTimeout(timer);
    nd.toggleAttribute("data-open", on);
    trigger.setAttribute("aria-expanded", on ? "true" : "false");
    if (on) panel.hidden = false;
    else timer = setTimeout(function () { panel.hidden = true; }, 240);
  }

  nd.addEventListener("mouseenter", function () { open(true); });
  nd.addEventListener("mouseleave", function () {
    clearTimeout(timer);
    timer = setTimeout(function () { open(false); }, 140);   // Grace period, so the panel is actually reachable
  });
  nd.addEventListener("focusin", function () { open(true); });
  nd.addEventListener("focusout", function (e) {
    if (!nd.contains(e.relatedTarget)) open(false);
  });
  trigger.addEventListener("keydown", function (e) {
    if (e.key === "Enter" || e.key === " ") { e.preventDefault(); open(!nd.hasAttribute("data-open")); }
  });
  nd.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { open(false); trigger.focus(); }
  });

  lines.forEach(function (b) {
    function pick() {
      var ln = b.getAttribute("data-nd-line");
      lines.forEach(function (x) {
        var on = x === b;
        x.classList.toggle("is-on", on);
        x.setAttribute("aria-pressed", on ? "true" : "false");
      });
      panes.forEach(function (p) { p.hidden = p.getAttribute("data-nd-panel") !== ln; });
    }
    b.addEventListener("mouseenter", pick);
    b.addEventListener("focus", pick);
    b.addEventListener("click", pick);
  });
})();
